<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.mobile_feature.news.news') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('administration.mobile_feature.news.news'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-8">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'news-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-4 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="
                $t('administration.mobile_feature.news.search_only_title')
              "
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch ? record.branch.branch_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.title }}
            </td>
            <td>
              <div
                v-html="record.content_en"
                style="max-height: 200px; overflow-y: scroll"
              ></div>
            </td>
            <td class="text-center">{{ record.created_by }}</td>
            <td class="text-center">{{ record.created_date }}</td>
            <td class="text-center">
              <a
                v-if="!record.is_sent"
                href="#"
                v-tooltip="$t('send')"
                class="mr-2 text-primary"
                @click.prevent="sendNotification(record)"
              >
                <i class="far fa-paper-plane"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger"
                @click.prevent="destroyNews(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <a-select
              style="width: 257px"
              v-model="branch_id"
              :options="branchs"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('all')"
            >
            </a-select>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'news',
  data () {
    return {
      loading: false,
      visible: false,
      branchs: []
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('news', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.news.search
      },
      set (newValue) {
        this.$store.commit('news/SET_SEARCH', newValue)
        this.$store.commit('news/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.news.branch_id
      },
      set (newValue) {
        this.$store.commit('news/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('administration.mobile_feature.news.branch') },
        { name: this.$t('administration.mobile_feature.news.title') },
        { name: this.$t('administration.mobile_feature.news.en_content') },
        {
          name: this.$t('administration.mobile_feature.news.created_by'),
          style: 'text-align:center; width: 9%;'
        },
        {
          name: this.$t('administration.mobile_feature.news.created_at'),
          style: 'text-align:center; width: 9%;'
        },
        {
          name: this.$t('administration.mobile_feature.news.actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'news/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (record) {
      this.$store.commit('news/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'news-edit',
        params: { id: record.news_id }
      })
    },

    async sendNotification (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_send'))) {
        record._deleting = true
        this.$store
          .dispatch('news/sendNotification', record.news_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    async destroyNews (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('news/destroy', record.news_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'news-create') {
      this.$store.commit('news/RESET_STATE')
    }
    next()
  }
}
</script>
